const recoverConstants = {
    VALIDATE_RECOVER_REQUEST: 'VALIDATE_RECOVER_REQUEST',
    VALIDATE_RECOVER_SUCCESS: 'VALIDATE_RECOVER_SUCCESS',
    VALIDATE_RECOVER_FAILURE: 'VALIDATE_RECOVER_FAILURE',

    RECOVER_REQUEST: 'RECOVER_REQUEST',
    RECOVER_SUCCESS: 'RECOVER_SUCCESS',
    RECOVER_FAILURE: 'RECOVER_FAILURE'
}
export { recoverConstants };